const ATTENDANCE = 'Asistencias'
const EXAMS = 'Examenes'
const FINAL = 'Examen Final'
const TASKS = 'Tareas'
const EXTRAS = 'extras'

export { ATTENDANCE, EXAMS, TASKS, FINAL, EXTRAS }
